import { Component } from '@angular/core';

@Component({
  templateUrl: './session-page.component.html',
})
export class SessionPageComponent {}
